export default function (gaParams: string[]) {
  try {
    const ga = (window as any).ga
    if (gaParams.length === 2) {
      ga('send', 'event', gaParams[0], gaParams[1])
    } else if (gaParams.length == 3) {
      ga('send', 'event', gaParams[0], gaParams[1], gaParams[2])
    }
  } catch (e) {
    console.error('GA Error!')
  }
}

export function logHomeEvent(category = '', action = '', label = '') {
  try {
    if (category && action) {
      window.ga('send', 'event', category, action, label)
    }
  } catch (e) {
    // console.error(e)
  }
}

export const gaEvent = ((category: string, action: string, label: string) => {
  window.dataLayer.push({
    'event': 'gaEvent',
    'eventCategory': category,
    'eventAction': action,
    'eventLabel': label
  });
})

export const gaTrial = ((action: string, label: string) => {
  window.dataLayer.push({
    'event': 'gaEvent',
    'eventCategory': "試用中心",
    'eventAction': action,
    'eventLabel': label
  });
})